import * as z from "zod";

export const getThirtyDaySales = {
  name: "getThirtyDaySales" as const,
  input: z.null(),
  output: z.object({
    orders: z.number().nullable(),
    /** In the store's currency; null without the Shopify `read_reports` scope. */
    totalSales: z.number().nullable(),
  }),
};
